import {
  Home,
  CourseList,
  MyClass,
  MyCourse,
  MyCoupon,
  VipCard,
  Union,
  Lecture,
  ClassDetail,
  MyCourseInfo,
  Pay,
  Cart,
  NotFound,
  Confirm,
  OrderInfo,
  GroupActivity,
  CouponActivity,
  LearningSituation,
  GetProton,
  Live,
  OfflineLive,
  Protons
} from '../views/'

export default [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: '',
        name: 'CourseList',
        meta: { keepAlive: true },
        component: CourseList
      },
      {
        path: '/my-class',
        name: 'MyClass',
        component: MyClass
      },
      {
        path: '/lecture',
        name: 'Lecture',
        meta: { keepAlive: true },
        component: Lecture
      }
    ]
  },
  {
    path: '/class-detail/:classId/:classType',
    name: 'ClassDetail',
    component: ClassDetail
  },
  {
    path: '/mycourse-detail/:classId/:classType/:vipCardId?',
    name: 'MyCourseInfo',
    component: MyCourseInfo
  },
  {
    path: '/pay/:orderNo',
    name: 'Pay',
    component: Pay
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart
  },
  {
    path: '/confirm/:activity_type/:classId/:class_type/:playBackList?/:activityId?',
    name: 'Confirm',
    component: Confirm
  },
  {
    path: '/mycourse/:state?',
    name: 'MyCourse',
    component: MyCourse
  },
  {
    path: '/orderDetail/:orderNo',
    name: 'orderDetail',
    component: OrderInfo
  },
  // 面授课回放
  {
    path: '/offline-live/:classId/:subId',
    name: 'offline-live',
    component: OfflineLive
  },
  // 直播间页面
  {
    path: '/live/:classId/:subId/:action?',
    name: 'live',
    component: Live
  },
  {
    path: '/groupActivity/:groupNo',
    name: 'groupActivity',
    component: GroupActivity
  },
  // 领取优惠券
  {
    path: '/couponActivity/:uuid',
    name: 'couponActivity',
    component: CouponActivity
  },
  // 学情信息
  {
    path: '/learningSituation/:classId/:subclassId',
    name: 'learningSituation',
    component: LearningSituation
  },
  // 领取质子（公共）
  {
    path: '/getProton/:excitationId/:excitationConfId?',
    name: 'getProton',
    component: GetProton
  },
  // 我的礼卷
  {
    path: '/mycoupon',
    name: 'MyCoupon',
    component: MyCoupon
  },
  // 联报页面
  {
    path: '/union/:unionId/:classId?',
    name: 'Union',
    component: Union
  },
  // 我的会员卡
  {
    path: '/vipcard/:vipCardId?',
    name: 'VipCard',
    component: VipCard
  },
  // 我的质子
  {
    path: '/protons',
    name: 'Protons',
    component: Protons
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
]
